import React, { useEffect, useState }  from 'react';

const SavedIcon = () => {
    const [isSaved, setIsSaved] = useState(false)

    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path style={{transition:'all 0.5s ease-in-out'}} onClick={() => setIsSaved(!isSaved)} className={isSaved && 'hover_saved'} d="M13.875 14.1478V6.05685C13.875 4.49604 12.7784 3.15263 11.2558 2.84828C9.76651 2.55057 8.23349 2.55057 6.74419 2.84828C5.22164 3.15263 4.125 4.49604 4.125 6.05684V14.1478C4.125 15.0944 5.14703 15.6835 5.9595 15.2052L8.179 13.8988C8.68608 13.6003 9.31392 13.6003 9.821 13.8988L12.0405 15.2052C12.853 15.6835 13.875 15.0944 13.875 14.1478Z" fill="white" fillOpacity="0.15" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default SavedIcon;